import { AmaxPayFullLogo, PartyImage } from '@approvalmax/ui';
import { Button, Grid, SimpleLayout, Text } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { getWebsiteUrl } from 'urlBuilder';

import { messages } from './resources/messages';

const Page = () => {
    return (
        <SimpleLayout size='small' verticalAlign='start' logo={<AmaxPayFullLogo />}>
            <Helmet title={messages.title} />

            <SimpleLayout.Content>
                <Grid gap={24} justifyItems='center'>
                    <PartyImage />

                    <Text font='headline' fontSize='small' fontWeight='medium' textAlign='center'>
                        {messages.formSubmitted}
                    </Text>

                    <Button color='blue80' size='large' as='a' href={getWebsiteUrl()}>
                        {messages.done}
                    </Button>
                </Grid>
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
